import {PayloadBuildersRegistry} from 'ui/adapters/Analytics';

import {createPayload as forAddSpend} from './addSpend';
import {createPayload as forAppendMoney} from './appendMoney';
import {createPayload as forDeleteSpend} from './deleteSpend';
import {createPayload as forCreateBudget} from './createBudget';
import {createPayload as forOpenHistory} from './openHistory';
import {createPayload as forTransferMoney} from './transferMoney';
import {createPayload as forUserSavedMoney} from './userSavedMoney';
import {createPayload as forUserSpentMoney} from './userSpentMoney';
import {EventKind} from 'services/analytics';

export const BuildersRegistry: PayloadBuildersRegistry = {
  [EventKind.OpenHistory]: forOpenHistory,

  [EventKind.AddSpend]: forAddSpend,
  [EventKind.AddIncome]: forAppendMoney,
  [EventKind.AddRefill]: forAppendMoney,
  [EventKind.DeleteSpend]: forDeleteSpend,

  [EventKind.CreateBudget]: forCreateBudget,
  [EventKind.UserSavedMoney]: forUserSavedMoney,
  [EventKind.UserSpentEverything]: forUserSpentMoney,

  [EventKind.RedistributeSaved]: forTransferMoney,
  [EventKind.TransferSavedToNextDay]: forTransferMoney,
};
